import React, { useState } from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";
import { useLanguage } from "../../i18n";

// Only 6 images for the home page - using verified working URLs
const HOME_GALLERY = [
  { id: 'home-1', url: 'https://customer-assets.emergentagent.com/job_aerial-performance/artifacts/2xztpazu_0CDB6C67-7F8E-4A0A-A127-873DB57E2172.png', title: 'Activación de marca' },
  { id: 'home-2', url: 'https://customer-assets.emergentagent.com/job_aerial-performance/artifacts/kvyua9ch_F3E666D8-2848-43FE-960B-B28ACE0CE2B7.png', title: 'Formación de drones' },
  { id: 'home-3', url: 'https://customer-assets.emergentagent.com/job_aerial-performance/artifacts/jcm85461_IMG_1225.png', title: 'Show nocturno' },
  { id: 'home-4', url: 'https://customer-assets.emergentagent.com/job_aerial-performance/artifacts/d3034cg8_6A963654-19C7-4164-B47B-66702E2CBB17.png', title: 'Evento masivo' },
  { id: 'home-5', url: 'https://customer-assets.emergentagent.com/job_aerial-performance/artifacts/6lghk188_6D5BE1DD-A003-4661-8A21-A95E8DAF5F00.png', title: 'Show corporativo' },
  { id: 'home-6', url: 'https://customer-assets.emergentagent.com/job_aerial-performance/artifacts/rvc6k1k9_D9E80893-54A2-4E3E-8B6C-CF39D72069E1.png', title: 'Lanzamiento inmobiliario' },
];

const ExperiencesSection = () => {
  const [lightboxImage, setLightboxImage] = useState(null);
  const { language } = useLanguage();

  return (
    <section id="experiencias" className="py-24 md:py-32 bg-[#050505]" data-testid="experiences-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            {language === 'es' ? 'Shows de' : 'Drone'}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
              {language === 'es' ? 'Drones' : 'Shows'}
            </span>
          </h2>
        </div>
        
        {/* Gallery Grid - Only 6 images */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {HOME_GALLERY.map((image) => (
            <div 
              key={image.id}
              className="group relative aspect-video rounded-xl overflow-hidden cursor-pointer border border-white/10 hover:border-cyan-500/30 transition-all"
              onClick={() => setLightboxImage(image)}
              data-testid={`gallery-item-${image.id}`}
            >
              <img 
                src={image.url} 
                alt={image.title}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform">
                <h4 className="text-white font-bold mt-1">{image.title}</h4>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-12">
          <a 
            href="#contacto"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-semibold transition-all hover:shadow-[0_0_30px_rgba(0,240,255,0.4)]"
            data-testid="cta-cotizar-drones"
          >
            {language === 'es' ? 'Cotizar Show de Drones' : 'Quote Drone Show'}
          </a>
          <Link 
            to="/show-de-drones"
            className="inline-flex items-center gap-2 px-6 py-3 text-cyan-400 hover:text-cyan-300 transition-colors"
          >
            {language === 'es' ? 'Ver más' : 'Learn more'}
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>

      {/* Lightbox */}
      {lightboxImage && (
        <div 
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
          onClick={() => setLightboxImage(null)}
        >
          <button 
            className="absolute top-6 right-6 text-white/60 hover:text-white transition-colors"
            onClick={() => setLightboxImage(null)}
          >
            <XCircle size={40} />
          </button>
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img 
              src={lightboxImage.url} 
              alt={lightboxImage.title}
              className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
            />
            <div className="mt-4 text-center">
              <h3 className="text-white text-xl font-bold">{lightboxImage.title}</h3>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ExperiencesSection;
